export const CDN_BASE_URL = "https://zimpler-assets.s3.ap-south-1.amazonaws.com"
export const CDN_IMAGES_URL = CDN_BASE_URL + "/images"
export const zimplerLogoNoBackground = CDN_IMAGES_URL + "/logo-no-background.png"